import Vue from 'vue';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

Vue.component('quote-slider-component', {
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentIndex: 1,
            maxIndex: 1,
            nextButton: null,
            prevButton: null,
            movement: null,
            inProgress: false,
            scrollTrigger: null,
            autoplayInterval: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.maxIndex = this.slides.length;
        this.inViewCheck();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setCurrentIndex(val) {
            if (this.currentIndex !== val) {
                if (this.inProgress) {
                    return;
                }

                this.inProgress = true;

                if (this.currentIndex < val) {
                    this.movement = 'top';
                } else {
                    this.movement = 'bottom';
                }

                this.currentIndex = val;
            }
        },

        nextSlide() {
            if (this.currentIndex === this.maxIndex) {
                this.setCurrentIndex(1);
                return;
            }

            this.setCurrentIndex(this.currentIndex + 1);
        },

        prevSlide() {
            if (this.currentIndex === 1) {
                this.setCurrentIndex(this.maxIndex);
                return;
            }

            this.setCurrentIndex(this.currentIndex - 1);
        },

        beforeEnter(el) {
            const imageHolder = el.querySelector('.quote-slider__slide-image-holder');
            const content = el.querySelector('.quote-slider__slide-content');
            const button = el.querySelector('.quote-slider__slide-content__button');

            if (this.movement === 'top') {
                gsap.set(imageHolder, { y: '100%' });
                gsap.set([content.children, button], { y: 10 });
            } else {
                gsap.set(imageHolder, { y: '-100%' });
                gsap.set([content.children, button], { y: -10 });
            }
            gsap.set(el, { autoAlpha: 1, zIndex: 2 });
            gsap.set([content.children, button], { autoAlpha: 0 });
        },

        enter(el, done) {
            const imageHolder = el.querySelector('.quote-slider__slide-image-holder');
            const content = el.querySelector('.quote-slider__slide-content');
            const button = el.querySelector('.quote-slider__slide-content__button');

            gsap.to([content.children, button], {
                autoAlpha: 1, y: 0, duration: 0.4, delay: 0.6, ease: 'power2.inOut', stagger: 0.05,
            });
            gsap.to(imageHolder, {
                y: 0, duration: 1, ease: 'power4.inOut', onComplete: done,
            });
        },

        afterEnter(el) {
            this.inProgress = false;
        },

        beforeLeave(el) {
        },

        leave(el, done) {
            const imageHolder = el.querySelector('.quote-slider__slide-image-holder');
            const content = el.querySelector('.quote-slider__slide-content');
            const button = el.querySelector('.quote-slider__slide-content__button');

            if (this.movement === 'top') {
                gsap.to(imageHolder, {
                    y: '-100%', duration: 1.3, ease: 'power4.inOut', onComplete: done,
                });
                gsap.to([content.children, button], {
                    y: -50, autoAlpha: 0, duration: 1.4, ease: 'power2.inOut', stagger: 0.05,
                });
            } else {
                gsap.to(imageHolder, {
                    y: '100%', duration: 1.3, ease: 'power4.inOut', onComplete: done,
                });
                gsap.to([content.children, button], {
                    y: 50, autoAlpha: 0, duration: 1.4, ease: 'power2.inOut', stagger: 0.05,
                });
            }
            gsap.set(el, { zIndex: 1 });
        },

        afterLeave(el) {
            gsap.set(el, { autoAlpha: 0 });
        },

        inViewCheck() {
            this.scrollTrigger = ScrollTrigger.create({
                trigger: this.$el,
                start: 'top bottom',
                end: 'bottom 50%',
                // markers: true,
                onEnter: () => {
                    this.autoplayInterval = setInterval(() => {
                        this.nextSlide();
                    }, 7500);
                },
                onLeave: () => {
                    clearInterval(this.autoplayInterval);
                    this.autoplayInterval = null;
                },
                onEnterBack: () => {
                    this.autoplayInterval = setInterval(() => {
                        this.nextSlide();
                    }, 7500);
                },
                onLeaveBack: () => {
                    clearInterval(this.autoplayInterval);
                    this.autoplayInterval = null;
                },
            });
        },
    },

    onBeforeDestroy() {
        this.scrollTrigger.kill();
        this.scrollTrigger = null;
        clearInterval(this.autoplayInterval);
    },
});
